// extracted by mini-css-extract-plugin
module.exports = {"buyerAssuranceFill":"_2491b024","buyerAssuranceBorder":"_150160a7","buyerAssuranceCheck":"_5ef54dad"};